import { Component } from "react";
import styles from "./show-booking-item.module.less";
import PropTypes from "prop-types";
import GlobalContext from "components/stores/global-context";
import SiteConfigurationStore from "components/stores/site-configuration-store";
import { ECommerceHelper, DateHelper, extract, CartContextConsumer, SecondaryButton } from "@parksandresorts/core";

export default class ShowBookingItem extends Component {
  static propTypes = {
    productName: PropTypes.string.isRequired,
    time: PropTypes.instanceOf(Date).isRequired,
    quantity: PropTypes.number.isRequired,
    remainingSlotsLimit: PropTypes.number.isRequired,
    timeslotId: PropTypes.number.isRequired,
    productData: PropTypes.shape({
      glkId: PropTypes.string.isRequired,
      jetshopId: PropTypes.number.isRequired,
      productType: PropTypes.string.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      isAddingToCart: false,
    };

    this.time = extract(props, "time");
    this.timeAsString = DateHelper.toStringTimeHHMM(this.time);
    this.title = extract(props, "title");
    this.timeslotId = extract(props, "timeslotId");
    this.quantity = extract(props, "quantity");
    this.productData = extract(props, "productData");
    this.jetshopConfig = ECommerceHelper.getJetshopConfig();
    this.addToCartLabel = this.jetshopConfig.bookShowAddToCartLabel;
    this.outOfStockLabel = this.jetshopConfig.bookShowOutOfStock;
    this.backgroundMode = props.backgroundMode ? props.backgroundMode : "light";
    this.onlyLabel = SiteConfigurationStore.getLabel("ONLY_LABEL", "Endast");
    this.timesSlotsLeftLabel = SiteConfigurationStore.getLabel("TIMESLOTS_LEFT_LABEL", "kvar");
    this.wholeDayActivityText = SiteConfigurationStore.getLabel("WHOLE_DAY_ACTIVITY");
    this.isAllDayActivity = extract(props, "isAllDayActivity");

    this.outOfStock = this.quantity === 0;

    this.isTimeSlotLimitReached = this.isTimeSlotLimitReached.bind(this);
  }

  addItemToCart(cartContext) {
    this.setState({ isAddingToCart: true }, () => {
      cartContext
        .addCartItem({
          jetshopId: parseInt(this.productData.jetshopId),
          glkId: this.productData.glkId,
          quantity: 1,
          productName: this.productName,
          productType: this.productData.productType,
          attributeId: 0,
          reactivateCardNumber: undefined,
          reactivateEmail: undefined,
          timeslotId: this.timeslotId,
        })
        .then((response) => this.addedToCartStatus(response))
        .catch((err) => {
          setTimeout(() => this.setState({ isAddingToCart: false }), 500);
          err && err.status
            ? alert(this.jetshopConfig.errorMessages.find((message) => message.key === err.status.toString()).value)
            : console.log(err);
        });
    });
  }

  addedToCartStatus(response) {
    if (response.isSuccess) {
      this.context.setValue({
        showCart: true,
        showMenu: false,
        showSearch: false,
        isMenuAnimating: true,
        isMenuAnimationDone: false,
      });
      setTimeout(() => this.setState({ isAddingToCart: false }), 1000);
    } else {
      this.setState({ isAddingToCart: false });
      alert(ECommerceHelper.getErrorMessage(response.message));
    }
  }

  isTimeSlotLimitReached(cartContext) {
    const cartItem = cartContext.products.find(
      (p) => p.jetshopId === this.productData.jetshopId && p.bookableItem && p.bookableItem.id === this.timeslotId,
    );

    if (cartItem) {
      return cartItem.quantity >= this.quantity;
    }

    return false;
  }

  renderItemButton() {
    return (
      <CartContextConsumer>
        {(cartContext) => {
          const isTimeSlotLimitReached = this.isTimeSlotLimitReached(cartContext);
          return (
            <SecondaryButton
              iconLeft={this.props.disabledAddToCart || this.state.isAddingToCart ? "icon-spinner" : ""}
              isDisabled={
                this.props.disabledAddToCart || this.state.isAddingToCart || this.outOfStock || isTimeSlotLimitReached
              }
              onClick={() => this.addItemToCart(cartContext)}
              label={this.outOfStock || isTimeSlotLimitReached ? this.outOfStockLabel : this.addToCartLabel}
              className={[
                styles.bookingBtn,
                this.props.disabledAddToCart || this.state.isAddingToCart ? styles.isLoading : styles.isIdle,
                "waves-effect",
              ].join(" ")}
            />
          );
        }}
      </CartContextConsumer>
    );
  }

  render() {
    return (
      <div className={styles.showBookingListItem}>
        <div className={styles.textWrapper}>
          {this.isAllDayActivity ? (
            <h5 className={[styles.headline, styles[this.backgroundMode]].join(" ")}>{this.wholeDayActivityText}</h5>
          ) : (
            this.timeAsString && (
              <h5 className={[styles.headline, styles[this.backgroundMode]].join(" ")}>{this.timeAsString}</h5>
            )
          )}
          {this.quantity < this.props.remainingSlotsLimit && (
            <span className={[styles.remainingTimeSlots, "p_tiny"].join(" ")}>
              {this.onlyLabel + " " + this.quantity + " " + this.timesSlotsLeftLabel}
            </span>
          )}
        </div>
        <div className={styles.buttonWrapper}>{this.renderItemButton()}</div>
      </div>
    );
  }
}

ShowBookingItem.contextType = GlobalContext;
